import {DayReport} from "@/data/entities/dayReport";
import {fromLocalDateString} from "@/utils/DateUtils";

/** Query key prefix of the day report, to refresh it after a change. */
export const DAY_REPORT_QUERY_KEY = "day-report";

/** The day of the report as a local date (the API sends `YYYY-MM-DD`). */
export const reportDay = (dayReport: DayReport): Date => fromLocalDateString(dayReport.date);

/** Orders that count for the revenue: paid online and in person, cancelled ones excluded. */
export const orderCount = (dayReport: DayReport): number =>
    dayReport.onlinePaidOrderCount + dayReport.inPersonPaidOrderCount;

/** Worked minutes as `hh:mm`, e.g. 1425 -> `23:45`. */
export const formatHoursMinutes = (minutes: number): string =>
    `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;

/** Average gross revenue per order, `null` without orders. */
export const averageOrderValue = (dayReport: DayReport): number | null => {
    const count = orderCount(dayReport);
    return count === 0 ? null : dayReport.grossRevenue / count;
};

/** Share (0-100) of the gross revenue paid online, `null` without revenue. */
export const onlineShare = (dayReport: DayReport): number | null =>
    dayReport.grossRevenue <= 0 ? null : Math.round(dayReport.paidOnline / dayReport.grossRevenue * 100);